import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorBoundary from '../../Errors/ErrorBoundary';
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { isClubOwner, isClubStaff, isUser } from "../../util/UserRoles";

const Protected = ({ Component }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(["access_token", "refresh_token"],);
  const  userInfo  = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);


  useEffect(()=>{
    if (selectedClub?.calendarType === 'EVENT_CALENDAR' && window.location.pathname.split('/').includes('calendar')) {
      navigate('/coach-scheduler');
    }
    if (selectedClub?.calendarType === 'RESERVATION_CALENDAR' && window.location.pathname.split('/').includes('coach-scheduler')) {
      navigate('/calendar');
    }
  },[selectedClub.clubId])

  useEffect(() => {
    if ((!cookies.access_token && !userInfo?.userId) || (!cookies.refresh_token && !userInfo?.userId)) {
      navigate("/login");
    } else if (userInfo.userId && isUser(userInfo)) {
   
      if (window.location.pathname.split('/').includes('players')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('transaction-insights')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('email-notify')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('plan-setup')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('calender-setup')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('club-setup')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('account')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('account-setup')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('invite-staff')) {
        navigate('*');
      } else if (window.location.pathname.split('/').includes('access-management')) {
        navigate('*');
      }
    }
    if (userInfo?.userId && !isClubOwner(userInfo)) {
      if (window.location.pathname.split('/').includes('access-management') || window.location.pathname.split('/').includes('finances')) {
        navigate('*');
      }
    }

  }, [cookies.access_token, cookies.refresh_token, userInfo?.userId]);

  return (
    <>
      <ErrorBoundary resetKey={location.pathname}>
        {((cookies.access_token && userInfo?.userId) || (cookies.refresh_token && userInfo?.userId)) && <Component />}
      </ErrorBoundary>
    </>
  )
}

export default Protected